import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { permission } from 'src/app/core/Constants/permissions';
import { SUB_TYPE, USER_TYPE } from 'src/app/core/Constants/static';
import { UserDetails } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { environment } from 'src/environments/environment';
import { UtilityService } from 'src/app/core/Services/utility.service';


@Component({
  selector: 'app-menubar',
  templateUrl: './menubar.component.html',
  styleUrls: ['./menubar.component.css'],
})
export class MenubarComponent implements OnInit {
  @ViewChild('subMenu') subMenu!: ElementRef<HTMLElement>;
  @ViewChild('MenuTab') MenuTab!: ElementRef<HTMLElement>;

  private clickListener!: EventListener;

  public user?: UserDetails;
  public showSubMenue: boolean = false;
  public aciveTab = '';
  public subTypes = SUB_TYPE
  public subTypeEvm = environment?.subscriberType ? environment?.subscriberType : this.subTypes.both;
  public permissions=permission
  public subActiveTab = '';
  
  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private utility : UtilityService
  ) {
    this.user = this.userService.getUserInfo()?.userDetails;
  }

  public ngOnInit(): void {
    this.getActiveTab();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd || event instanceof NavigationStart) {
        this.getActiveTab();
      }
    });
  }

  public showPrefferedDrugList(): string {
    if (
      this.user?.userType === USER_TYPE.payer && this.checkPermission('getPreferredDrugListCode')) {
      return '/preferred-druglist/drugcodelist';
    }
    // else if (this.user?.userType === USER_TYPE.provider && this.checkPermission('getPreferredDrugListProvier')) {
    //   return '/preferred-druglist/druglist';
    // }
    else {
      return '/preferred-druglist/preferreddruglist';
    }
  }

  public checkPermission(perName: string): boolean {
    return this.userService.getPermissions(perName);
  }

  private getActiveTab(): void {
    const arr = this.router.url.trim().split('/');
    if (arr.length) {
      this.aciveTab = arr[1];
      if (arr[1] === 'preferred-druglist') {
        const drugListRoutes = [ 'preferreddruglist', 'preferred-detail-view','drugcodelist'];
        if (drugListRoutes.includes(arr[2])) {
          this.aciveTab = 'prefferedDrugList';
        }
        if (arr[2] === 'masterDrugList' || arr[2] === 'master-detail-view') {
          this.aciveTab = 'drugList';
        }
        return;
      }
      const generalSettingsRoutes = ['user-management', 'settings-management', 'acl-management','role-management'];
      if (generalSettingsRoutes.includes(arr[1])) {
        this.aciveTab = 'generalSettings';
        this.subActiveTab='';
        return;
      }
      else if (arr[1] == 'master-management') {
        const masterMangementRoutes = ['diagnosis-management', 'allergy-management', 'allergy-detail-view', 'diagnosis-detail-view'];
        if (masterMangementRoutes.includes(arr[2])) {
          // this.aciveTab = 'masterManagement';
          this.aciveTab = 'generalSettings';
          if (arr[2] == 'allergyManagement') {
            this.subActiveTab = 'allergy-detail-view';
          }
          else if (arr[2] == 'diagnosis-detail-view') {
            this.subActiveTab = 'diagnosisManagement';
          }
          return;
        }
      }
      else if (arr[1] === 'rule-engine') {
        this.aciveTab = 'rule';
        return;
      }
    }
  }

  public listenOutsideClick(): void {
    this.clickListener = (event: Event) => {
      const targetElement = event.target as Node;
      const subMenu = this.MenuTab.nativeElement;
      if (targetElement && !subMenu?.contains(targetElement)) {
        this.showSubMenue = false;
        document.removeEventListener('click', this.clickListener);
      }
    }
    document.addEventListener('click', this.clickListener);
  }

  public heading(): string {
    if (this.subTypeEvm == this.subTypes.both) {
      if (this.user?.userType == USER_TYPE.payer) {
        return 'Payers';
      } else if (this.user?.userType == USER_TYPE.provider) {
        return 'Providers';
      } else {
        return 'Providers/Payers';
      }
    }
    else if (this.subTypeEvm == this.subTypes.provider) {
      return 'Providers'
    }
    else if (this.subTypeEvm == this.subTypes.payer) {
      return 'Payers'
    }
    else {
      return '';
    }
  }

  public removeLock(): void {
    let arr = this.router.url.split('/');
    if(arr.indexOf('detail-view')!=-1){
      let id = arr[arr.length-1];
      // let page = arr[arr.length-3] == 'prescription' ? 'prescription': 'authorizations';
      let page = 'prescription';

      if(id){
        this.utility.unlockView(page,id).subscribe()
      }
    }
  }

}
